<template>
    <div class="page">
        <sort-list
            v-model="list"
            :defaultQuery="defaultQuery"
            :sortKey="sortKey"
            :newsList="newsList"
            ref="list"
            url="/policyLaw/all"
            :filters="filters"
        >
            <!-- <div class="border"></div> -->
            <div v-for="item in list" :key="item.id">
                <news-row :key="item.id" :info="item"></news-row>
            </div>
        </sort-list>
    </div>
</template>

<script>
import newsRow from './list/newsRow.vue';
import SortList from './page/SortList.vue';
import { policyLevel } from '../utils/variables';
export default {
    components: { SortList, newsRow },
    created() {
        this.init();
    },
    data() {
        return {
            list: [],
            policyLevel,
            defaultQuery: {
                category: 'NEWS',
                typeSettingId: 3240
            },
            sortKey: [
                {
                    name: '发布时间',
                    key: 'issuedAt'
                }
            ],
            newsList: true
        };
    },
    computed: {
        filters() {
            return [
                // {
                //     name: '专利区分',
                //     key: 'typeId',
                //     type: 'select',
                //     list: [...this.typeOptions],
                //     default: this.$route.query.typeId ? Number(this.$route.query.typeId) : ''
                // },
                // {
                //     name: '筛选政策层级',
                //     key: 'industryClass',
                //     type: 'select',
                //     list: [...this.policyLevel]
                // },
                // {
                //     name: '法律状态',
                //     key: 'lawStatusId',
                //     type: 'select',
                //     list: [...this.intePropLawStatus]
                // },

                {
                    name: '政策名称',
                    key: 'name'
                },
                {
                    name: '发布年份',
                    key: 'issuedAt',
                    type: 'date'
                },
                {
                    name: '发文单位',
                    key: 'issuedBy'
                },
                {
                    name: '发文号',
                    key: 'issuedCode'
                }
            ];
        }
    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.$refs.list.init();
            });
        }
    }
};
</script>

<style lang="less" scoped>
.page {
    padding-top: 20px;
}
.border {
    border-bottom: 20px solid @bg;
}
</style>
